import { useSendbirdContext } from '../../../resources/Chat/SendbirdProviderWithSDK';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import { GroupChannelHandler } from '@sendbird/chat/groupChannel';

export const useGetTotalUnreadMessageCount = (options?: {
  enabled?: boolean;
}) => {
  const enabled = options?.enabled ?? true;
  const { sb } = useSendbirdContext();
  const queryClient = useQueryClient();
  const queryKey = useMemo(() => ['total-unread-message-count'], []);
  const unreadMessageHandlerKey = useMemo(() => crypto.randomUUID(), []);

  useEffect(() => {
    if (!enabled || !sb?.groupChannel) {
      return;
    }

    const handler = new GroupChannelHandler({
      onUnreadMemberStatusUpdated: () => {
        void queryClient.invalidateQueries({ queryKey });
      },
      onMessageReceived: () => {
        void queryClient.invalidateQueries({ queryKey });
      },
      onChannelChanged: () => {
        void queryClient.invalidateQueries({ queryKey });
      },
    });

    sb.groupChannel.addGroupChannelHandler(unreadMessageHandlerKey, handler);

    return () => {
      sb.groupChannel.removeGroupChannelHandler(unreadMessageHandlerKey);
    };
  }, [enabled, sb, queryClient, unreadMessageHandlerKey, queryKey]);

  return useQuery({
    queryKey,
    queryFn: async () => {
      if (!sb?.groupChannel) {
        return 0;
      }

      try {
        const unreadCount = await sb.groupChannel.getTotalUnreadMessageCount();
        return unreadCount;
      } catch (error) {
        console.error(error);
        return 0;
      }
    },
    enabled,
    staleTime: 10_000,
  });
};
